<template lang="pug">
Layout
  PageHeader(:title="title")
  .row
    .col-lg-12
      //- 表格
      b-card
        b-card-body
          .header-row.mt-0.mb-3.d-flex.justify-content-between.align-items-end
            .d-flex.align-items-end.flex-wrap
              .form-group.mb-0.mr-2
                label.small 關鍵字
                input.form-control.form-control-sm(
                  type="text"
                  v-model="search.keyword"
                  placeholder="搜尋標題"
                  style="width:150px"
                )
              .form-group.mb-0.mr-2
                label.small 類型
                select.form-control.form-control-sm(v-model="search.type" style="width:120px")
                  option(value="") 全部
                  option(value="1") 檔案
                  option(value="2") 連結
              .form-group.mb-0.mr-2
                label.small 模式
                select.form-control.form-control-sm(v-model="search.mode" style="width:120px")
                  option(value="") 全部
                  option(value="1") 通用
                  option(value="2") 活動
                  option(value="3") 公告
                  option(value="4") 新聞稿
              .form-group.mb-0.mr-2
                label.small 建立日期區間
                date-picker.form-control-sm(
                  v-model="search.date_range"
                  range
                  format="YYYY-MM-DD"
                  value-type="format"
                  append-to-body
                  lang="zh"
                  placeholder="選擇起迄日期"
                  style="width:240px"
                )
              b-button.mr-2(size="sm" variant="info" @click="doSearch()" :disabled="loading")
                span(v-if="loading")
                  b-spinner.mr-1(small)
                  | 載入中...
                span(v-else) 搜尋
              b-button(size="sm" variant="outline-secondary" @click="resetSearch()") 重置
            .d-flex
              b-button.width-md.mr-2(variant="success" @click="exportFiles()") 匯出 Excel
              b-button.width-md(variant="primary",:to="'/file-edit/create'") ＋ 新增
          //- Table
          .table-responsive.mb-0
            table.table
              thead
                th #
                th 檔案名稱
                th 檔案類型
                th 模式
                th 短網址
                th QRCode
                th 公開起始日
                th 公開結束日
                th 觀看人數
                th 備註
                th 操作
              tbody
                tr(v-for="( file, index ) in files")
                  td {{ index + 1 }}
                  td {{ file.title }}
                  td
                    span(v-if="file.type == 1") 檔案
                    span(v-if="file.type == 2") 連結
                  td {{ file.mode_label || '通用' }}
                  td.max-width-200 {{ (file.customize_link ? file.customize_link : file.sort_uri) }}
                  td
                    .qrcode_box
                      qr-code(:text='(file.customize_link ? file.customize_link : file.sort_uri)' :size='50' color='#000' bg-color='#fff' error-level='L')
                  td {{ ( file.start_date ) ? file.start_date : '-' }}
                  td {{ ( file.end_date ) ? file.end_date : '-' }}
                  td.center {{ file.view_count || 0 }}
                  td.center
                    a.text-primary(v-if="file.remark" href="javascript:;" @click="showRemark(file)") 查看
                    span.text-muted(v-else) -
                  td
                    b-button.table-btn(variant="primary" :to="'/file-edit/' + file.id")
                      | 編輯
                    b-button.ml-2.table-btn(variant="danger" @click="deleteFile(file.id)")
                      | 刪除


          .row.mb-md-2
            .col
              div(class="dataTables_paginate paging_simple_numbers float-right")
                ul.pagination.pagination-rounded.mb-0
                  b-pagination(v-model="currentPage", :total-rows="totalRows", :per-page="perPage")

    b-modal(v-model="remarkModal.show" :title="remarkModal.title" ok-only ok-title="關閉")
      p(style="white-space:pre-wrap") {{ remarkModal.content }}
</template>

<script>
import Layout from "../layouts/main";
import PageHeader from "@/components/Page-header";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";

/**
 * Starter component
 */
export default {
  name: "FileList",
  data () {
    return {
      title: "檔案管理",
      totalRows: 0,
      currentPage: 1,
      perPage: 0,
      filter: null,
      filterOn: [],
      sortDesc: false,
      loading: false,
      search: {
        keyword: '',
        type: '',
        mode: '',
        date_range: null,
      },
      remarkModal: {
        show: false,
        title: '',
        content: '',
      },
      files: [],
      fields: [
        { key: "index", label: "#", sortable: false, class: "center" },
        { key: "title", label: "檔案名稱", sortable: false, class: "" },
        { key: "type", label: "檔案類型", sortable: false, class: "" },
        { key: "sort_uri", label: "短網址", sortable: false, class: "center" },
        { key: "qrcode", label: "QRCode", sortable: false, class: "center" },
        { key: "start_date", label: "公開起始日", sortable: false, class: "center" },
        { key: "end_date", label: "公開結束日", sortable: false, class: "center" },
        { key: "views", label: "觀看人數", sortable: false, class: "center" },
        { key: "editor", label: "操作", sortable: false, class: "center" }
      ]
    };
  },
  computed: {
  },
  mounted () {
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
    DatePicker,
  },
  created () {
    this.getFiles()
  },
  watch: {
    currentPage (_page) {
      this.getFiles()
    }
  },
  methods: {
    doSearch () {
      this.currentPage = 1
      this.getFiles()
    },
    exportFiles () {
      this.$root.apis.exportFileList(this.search)
    },
    resetSearch () {
      this.search = { keyword: '', type: '', mode: '', date_range: null }
      this.currentPage = 1
      this.getFiles()
    },
    showRemark (file) {
      this.remarkModal.title = file.title + ' - 備註'
      this.remarkModal.content = file.remark
      this.remarkModal.show = true
    },
    deleteFile (fileId) {
      let vm = this
      this.$root.common.confirmAction(
        '確定要刪除嗎？',
        '刪除後將無法復原',
        '確定刪除',
        '取消',
        function () {
          vm.$root.apis.deleteFileItem(fileId, function () {
            vm.$root.common.showSingleNotify('檔案已刪除')
            vm.getFiles()
          })
        }
      )
    },
    async getFiles () {
      let vm = this
      this.loading = true
      let params = { page: this.currentPage }
      if (this.search.keyword) params.keyword = this.search.keyword
      if (this.search.type) params.type = this.search.type
      if (this.search.mode) params.mode = this.search.mode
      if (this.search.date_range && this.search.date_range[0]) params.created_start = this.search.date_range[0]
      if (this.search.date_range && this.search.date_range[1]) params.created_end = this.search.date_range[1]
      await this.$root.apis.getFileList(params,
        async function (_response) {
          let response = _response.body.data
          vm.totalRows = response.total
          vm.currentPage = response.page
          vm.perPage = response.per_page
          vm.files = response.items
          vm.loading = false
        }, function () {
          vm.loading = false
        })
    },
  }
}
</script>

<style lang="sass" scoped>
.title-box
  display: flex
  justify-content: space-between
  align-items: center
.header-row
  display: flex
  justify-content: space-between
  align-items: center
  .header-title
    margin: 0
    flex: 1
.tab-group
  background: rgba(229,231,235,1)
  padding: 0.5rem 1rem
.max-width-200
  max-width: 200px
</style>
